import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Справочник содержит информацию о паллетах и рулонах.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Наименование – наименование паллета/рулона"),
  /*#__PURE__*/_createElementVNode("li", null, "Длина, Ширина, Высота (мм), Диаметр – размеры паллета/рулона"),
  /*#__PURE__*/_createElementVNode("li", null, "Вес (кг) – вес паллета/рулона")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoDialog = _resolveComponent("InfoDialog")!

  return (_openBlock(), _createBlock(_component_InfoDialog, {
    title: "Справка: Паллеты",
    ref: "dialog"
  }, {
    infoForm: _withCtx(({}) => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }, 512))
}